import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { WhatsAppDialogsModule } from 'src/app/shared/whatsapp-dialogs.module';
import { CurdBaseModule } from 'src/app/shared/base/curd-base.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IconModule } from '@visurel/iconify-angular';
import { ColorFadeModule } from 'src/@core/pipes/color/color-fade.module';
import { MaterialShared } from 'src/app/shared/material-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { JobComponent } from './job/job.component';
import { AddEditJobComponent } from './job/add-edit-job/add-edit-job.component';
import { ViewJobComponent } from './job/view-job/view-job.component';
import { AddEditProjectComponent } from './job/add-edit-project/add-edit-project.component';
import { SuccessModalComponent } from './job/success-modal/success-modal.component';
import { JobBurgerMenuComponent } from './job/job-burger-menu/job-burger-menu.component';
import { CreateQuoteComponent } from './job/quotes/create-quote/create-quote.component';
import { QuoteListComponent } from './job/quotes/quote-list/quote-list.component';
import { CompareQuotesComponent } from './job/quotes/compare-quotes/compare-quotes.component';
import { ViewQuoteComponent } from './job/quotes/view-quote/view-quote.component';
import { ViewJobDetailsComponent } from './job/view-job/view-job-details/view-job-details.component';
import { CreatePurchaseOrderComponent } from './job/purchase-orders/create-purchase-order/create-purchase-order.component';
import { PurchaseOrderListComponent } from './job/purchase-orders/purchase-order-list/purchase-order-list.component';
import { CreateBillComponent } from './job/bills/create-bill/create-bill.component';
import { BillListComponent } from './job/bills/bill-list/bill-list.component';
import { WorkordersComponent } from './job/workorders/workorders.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { EditViewBillDetailsComponent } from './job/bills/edit-view-bill-details/edit-view-bill-details.component';
import { ViewPurchaseOrderComponent } from './job/purchase-orders/view-purchase-order/view-purchase-order.component';
import { DeleteFileComponent } from './job/bills/delete-file/delete-file.component';
import { PayBillComponent } from './job/bills/pay-bill/pay-bill.component';
import { AgmCoreModule } from '@agm/core';
import { MapViewWithProjectComponent } from './job/map-view-with-project/map-view-with-project.component';
import { SignContractPopupComponent } from './job/sign-contract-popup/sign-contract-popup.component';
import { AgreementDocComponent } from './job/agreement-doc/agreement-doc.component';
import { SignedDocumentComponent } from './job/signed-document/signed-document.component';
import { SuccessSignedPageComponent } from './job/success-signed-page/success-signed-page.component';
import { AssignVendorComponent } from '../enterprise-admin/users/assign-vendor/assign-vendor.component';
import { AddEditProjectNewComponent } from './job/add-edit-project-new/add-edit-project-new.component';
import { MatStepperModule } from '@angular/material';
import { CustomFieldsComponent } from './job/add-edit-project-new/custom-fields/custom-fields.component';
import { AssignedMembersComponent } from './job/assigned-members/assigned-members.component';
import { AssignMembersComponent } from './job/assigned-members/assign-members/assign-members.component';
import { AttendanceSheetComponent } from './job/attendance-sheet/attendance-sheet.component';
import { UploadBulkWorkordersComponent } from './job/workorders/upload-bulk-workorders/upload-bulk-workorders.component';
import { AssignedVendorsComponent } from './job/assigned-vendors/assigned-vendors.component';
import { CreateEditProjectComponent } from './job/create-edit-project/create-edit-project.component';
import { ViewProjectComponent } from './job/view-project/view-project.component';
import { CreateLeadsUserComponent } from './job/view-project/create-leads-user/create-leads-user.component';
import { ViewProjectNewComponent } from './job/view-project-new/view-project-new.component';
import { ProjectAgentComponent } from './job/project-agent/project-agent.component';
import { OutcomeReviewCopilotComponent } from './job/outcome-review-copilot/outcome-review-copilot.component';
import { ViewProjectDetailsNewComponent } from './job/view-project-new/view-project-details-new/view-project-details-new.component';
import { TestAgentDialogComponent } from './job/view-project-new/view-project-details-new/test-agent-dialog.component';
import { WABAConnectDialogComponent } from './job/view-project-new/view-project-details-new/waba-connect-dialog.component';
import { CreateLeadsUserNewComponent } from './job/view-project-new/create-leads-user-new/create-leads-user-new.component';
import { ViewSearchComponent } from './job/view-project-new/view-search/view-search.component';
import { WorkflowPopupComponent } from './job/workflow-popup/workflow-popup.component';
import { WorkflowStepperComponent } from './job/workflow-stepper/workflow-stepper.component';
import { ConnectedLeadsComponent } from './job/connected-leads/connected-leads.component';
import { GoogleAccountPopupComponent } from './job/google-account-popup/google-account-popup.component';
import { ClientProfileComponent } from './job/view-project-new/client-profile/client-profile.component';
import { ExperienceEducationComponent } from './job/view-project-new/client-profile/experience-education/experience-education.component';
import { ActivityHistoryComponent } from './job/view-project-new/client-profile/activity-history/activity-history.component';
import { WhatsAppChatHistoryComponent } from './job/view-project-new/client-profile/whatsapp-chat-history/whatsapp-chat-history.component';
import { RunOutreachPopupComponent } from './job/view-project-new/run-outreach-popup/run-outreach-popup.component';
import { CallAgentComponent } from '../agents/call-agent/call-agent.component';
import { CallSummaryPopupComponent } from './job/connected-leads/call-summary-popup/call-summary-popup.component';
import { EditTasksPopupComponent } from './job/connected-leads/edit-tasks-popup/edit-tasks-popup.component';
import { SignalDetailPopupComponent } from './job/connected-leads/signal-detail-popup/signal-detail-popup.component';
import { EditOutcomePopupComponent } from './job/connected-leads/edit-outcome-popup/edit-outcome-popup.component';
import { AgentThinkingUiComponent } from './job/agent-thinking-ui/agent-thinking-ui.component';
import { AdjustIcpComponent } from './job/adjust-icp/adjust-icp.component';
import { JobPostComponent } from './job/view-project-new/job-post/job-post.component';
import { ScriptEditorDialogComponent } from './job/workflow-stepper/script-editor-dialog/script-editor-dialog.component';
import { WaTemplateLibraryDialogComponent } from './job/workflow-stepper/wa-template-library-dialog/wa-template-library-dialog.component';
import { LiveTranscriptionComponent } from './job/view-project-new/client-profile/live-transcription/live-transcription.component';
import { EntityOutcomesPageComponent } from './job/entity-leads/entity-outcomes-page/entity-outcomes-page.component';
import { EntityLeadsSharedModule } from './job/entity-leads/shared/entity-leads-shared.module';
import { TasksCustomSelectComponent } from './job/entity-leads/shared/tasks-custom-select.component';
import { EntityTasksPageComponent } from './job/entity-leads/entity-tasks-page/entity-tasks-page.component';
import { ProjectTasksComponent } from './job/view-project-new/project-tasks/project-tasks.component';
import { ProjectFunnelComponent } from './job/view-project-new/funnel/project-funnel.component';
import { ConnectedFunnelComponent } from './job/connected-leads/connected-funnel.component';
import { FunnelBuilderComponent } from './job/view-project-new/funnel/funnel-builder.component';
import { LoopConfigComponent } from './job/view-project-new/loop/loop-config.component';
import { ProjectSettingsComponent } from './job/view-project-new/funnel/project-settings.component';
import { ProjectLoopComponent } from './job/view-project-new/loop/project-loop.component';
import { MyLeadsComponent } from './job/my-leads/my-leads.component';
import { AssignedLeadsComponent } from './job/assigned-leads/assigned-leads.component';
import { CreateTaskDialogComponent } from './job/entity-leads/create-task-dialog/create-task-dialog.component';
import { TaskActionDialogComponent } from './job/entity-leads/task-action-dialog/task-action-dialog.component';
import { DeleteFollowUpTasksDialogComponent } from './job/connected-leads/delete-followup-tasks-dialog/delete-followup-tasks-dialog.component';
import { AgentEvalsComponent } from './job/agent-evals/agent-evals.component';
import { AddAgentEvalTestDialogComponent } from './job/agent-evals/add-test-dialog/add-test-dialog.component';
import { GenerateAgentEvalTestsDialogComponent } from './job/agent-evals/generate-tests-dialog/generate-tests-dialog.component';
import { RunAgentEvalsDialogComponent } from './job/agent-evals/run-evals-dialog/run-evals-dialog.component';
import { AgentEvalSuccessRulesDialogComponent } from './job/agent-evals/success-rules-dialog/success-rules-dialog.component';
import { AgentEvalTestResultDialogComponent } from './job/agent-evals/test-result-dialog/test-result-dialog.component';
import { AgentEvalReportDialogComponent } from './job/agent-evals/report-dialog/report-dialog.component';

// import { EmploymentMapViewComponent } from '../employment/active-employments/employment-map-view/employment-map-view.component';

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: ''
  // },
  {
    path: '', component: JobComponent
  },
  {
    path: 'view/:id', component: ViewJobComponent
  },
  {
    path: 'view-project/:id', component: ViewProjectComponent
  },
  {
    path: 'view-new-project',
    component: ViewProjectNewComponent
  },
  {
    path: 'view-new-project/:id',
    component: ViewProjectNewComponent
  },
  {
    path: 'view-new-project/job-post/:id',
    component: JobPostComponent
  },
  {
    path: 'view/:id/:selectedTab', component: ViewJobComponent
  },
  {
    path: 'quote/:id', component: ViewQuoteComponent
  },
  {
    path: 'purchase-order/:id', component: ViewPurchaseOrderComponent
  },
  {
    path: 'quotes', component: QuoteListComponent
  },
  {
    path: 'create-bill/:id', component: CreateBillComponent
  },
  {
    path: 'signed-doc', component: SignedDocumentComponent
  },
  {
    path: 'signed-doc/:id', component: SignedDocumentComponent
  },
  {
    path: 'success-signed-doc/:id', component: SuccessSignedPageComponent
  },
  {
    path: 'create-project', component: AddEditProjectNewComponent
  },
  // {
  //   path: 'create-project/:id', component: AddEditProjectNewComponent
  // },
  {
    path: 'create-project/:id/:action', component: AddEditProjectNewComponent
  },
  // {
  //   path: 'create-project-new', component: CreateEditProjectNewComponent
  // },
  // {
  //   path: 'create-project-new/:id/:entityId', component: CreateEditProjectNewComponent
  // },
  {
    path: 'create-new-project', component: CreateEditProjectComponent
  },
  // {
  //   path: 'create-new-project/:id', component:CreateEditProjectComponent
  // },
  {
    path: 'create-new-project/:id/:action', component: CreateEditProjectComponent
  },
  {
    path: 'view-new-project/:projectId/setup-workflow', component: WorkflowStepperComponent
  },
  {
    path: 'tasks', component: EntityTasksPageComponent
  },
  {
    path: 'my-leads', component: MyLeadsComponent
  },
  {
    path: 'outcomes', component: EntityOutcomesPageComponent
  }

];


@NgModule({
  declarations: [JobComponent, AddEditJobComponent, ViewJobComponent, AddEditProjectComponent, SuccessModalComponent, JobBurgerMenuComponent, CreateQuoteComponent, QuoteListComponent, CompareQuotesComponent, ViewQuoteComponent, ViewJobDetailsComponent, CreatePurchaseOrderComponent, PurchaseOrderListComponent, CreateBillComponent, BillListComponent, WorkordersComponent, EditViewBillDetailsComponent, ViewPurchaseOrderComponent, DeleteFileComponent, PayBillComponent, MapViewWithProjectComponent, SignContractPopupComponent, AgreementDocComponent, SignedDocumentComponent, SuccessSignedPageComponent, AssignVendorComponent, AddEditProjectNewComponent, CustomFieldsComponent, AssignedMembersComponent, AssignMembersComponent, AttendanceSheetComponent, AssignedVendorsComponent, UploadBulkWorkordersComponent, CreateEditProjectComponent, ViewProjectComponent, CreateLeadsUserComponent, ViewProjectNewComponent, ViewProjectDetailsNewComponent, TestAgentDialogComponent, WABAConnectDialogComponent, CreateLeadsUserNewComponent, ViewSearchComponent, WorkflowPopupComponent, WorkflowStepperComponent, ConnectedLeadsComponent, GoogleAccountPopupComponent, ClientProfileComponent, ExperienceEducationComponent, ActivityHistoryComponent, WhatsAppChatHistoryComponent, RunOutreachPopupComponent, CallAgentComponent, CallSummaryPopupComponent, AgentThinkingUiComponent, AdjustIcpComponent, JobPostComponent, ScriptEditorDialogComponent, WaTemplateLibraryDialogComponent, EditTasksPopupComponent, SignalDetailPopupComponent, EditOutcomePopupComponent, LiveTranscriptionComponent, EntityTasksPageComponent, ProjectTasksComponent, ProjectLoopComponent, ProjectSettingsComponent, ConnectedFunnelComponent, FunnelBuilderComponent, LoopConfigComponent, ProjectFunnelComponent, EntityOutcomesPageComponent, TasksCustomSelectComponent, CreateTaskDialogComponent, TaskActionDialogComponent, DeleteFollowUpTasksDialogComponent, OutcomeReviewCopilotComponent, MyLeadsComponent, AssignedLeadsComponent, ProjectAgentComponent, AgentEvalsComponent, AddAgentEvalTestDialogComponent, GenerateAgentEvalTestsDialogComponent, RunAgentEvalsDialogComponent, AgentEvalSuccessRulesDialogComponent, AgentEvalTestResultDialogComponent, AgentEvalReportDialogComponent],

  imports: [
    FlexLayoutModule,
    IconModule,
    ColorFadeModule,
    MaterialShared,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    EntityLeadsSharedModule,
    WhatsAppDialogsModule,
    CurdBaseModule,
    RouterModule.forChild(routes),
    NgxDaterangepickerMd.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCapq8M5KTmGYayG3x7mLHSD2qXfzmyTC4',
      libraries: ['places', 'drawing', 'geometry']
    }),
    MatStepperModule
  ],
  entryComponents: [
    AddEditJobComponent,
    SuccessModalComponent,
    JobBurgerMenuComponent,
    CreateQuoteComponent,
    QuoteListComponent,
    CompareQuotesComponent,
    ViewJobDetailsComponent,
    CreatePurchaseOrderComponent,
    PurchaseOrderListComponent,
    BillListComponent,
    WorkordersComponent, EditViewBillDetailsComponent,
    DeleteFileComponent, PayBillComponent, MapViewWithProjectComponent,
    SignContractPopupComponent, AgreementDocComponent, AssignVendorComponent, CustomFieldsComponent,
    AssignedMembersComponent, AssignMembersComponent, AttendanceSheetComponent, UploadBulkWorkordersComponent,
    CreateLeadsUserComponent, ViewSearchComponent, ViewProjectDetailsNewComponent, WorkflowPopupComponent,
    GoogleAccountPopupComponent, ClientProfileComponent, ExperienceEducationComponent,
    ActivityHistoryComponent, RunOutreachPopupComponent, CallAgentComponent,
    CallSummaryPopupComponent, AdjustIcpComponent, TestAgentDialogComponent, WABAConnectDialogComponent, ScriptEditorDialogComponent, WaTemplateLibraryDialogComponent, EditTasksPopupComponent, SignalDetailPopupComponent, EditOutcomePopupComponent, CreateTaskDialogComponent, TaskActionDialogComponent, DeleteFollowUpTasksDialogComponent, OutcomeReviewCopilotComponent, AddAgentEvalTestDialogComponent, GenerateAgentEvalTestsDialogComponent, RunAgentEvalsDialogComponent, AgentEvalSuccessRulesDialogComponent, AgentEvalTestResultDialogComponent, AgentEvalReportDialogComponent],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})



export class JobModule { }
